import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Card,
	CardBody,
	Input,
	Label,
	Button,
	Form,
	Alert,
	FormGroup,
	Badge,
} from "reactstrap";
import { post, get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TimeSlotDet from "./TimeSlotDet";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ADD_TIMESLOT_EXCEPTION, SHOW_TIMESLOT_EXCEPTION, SEARCH_TIMESLOT } from "helpers/api_endpoints";
import Select from "react-select";
import moment from "moment"

document.title = "Add Time Slot Exception";

const AddTimeSlotException = () => {
	const navigate = useNavigate();
	const params = useParams();
	const [partnerBranchId, setPartnerBranchId] = useState(0)
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");
	const [partnerBranches, setPartnerBranches] = useState([])

	// Form state
	const [name, setName] = useState("");
	const [timeslots, setTimeSlots] = useState([]);
	const [timeslotId, setTimeslotId] = useState(0);
	const [slotDateFrom, setSlotDateFrom] = useState("");
	const [slotDateTo, setSlotDateTo] = useState("");
	const [daysOfWeek, setDaysOfWeek] = useState([]);
	const [expectedOrders, setExpectedOrders] = useState(0);
	const [status, setStatus] = useState(1);
	const [dets, setDets] = useState([{timeFrom:'', timeTo:'', prepareTimeFrom:'', prepareTimeTo:'', maxVolume:'0', selected:'0'}]);
	const [selectedDets, setSelectedDets] = useState([]);

	// Day options for recurring days
	const dayOptions = [
		{ value: 0, label: "Sunday" },
		{ value: 1, label: "Monday" },
		{ value: 2, label: "Tuesday" },
		{ value: 3, label: "Wednesday" },
		{ value: 4, label: "Thursday" },
		{ value: 5, label: "Friday" },
		{ value: 6, label: "Saturday" },
	];

    useEffect(() => {
        post(SEARCH_TIMESLOT)
            .then(response => {
                const temp = response.data.map(el=>{
                    return {value:el.id,label:el.name, dets:el.timeSlotDet}
                });
                setTimeSlots(temp);
            })
            .catch(error => {
                console.log(error)
                // seterrorMsg('Loading Failed');
            })
    }, []);

    useEffect(() => {
		if(params.id != undefined)
        get(SHOW_TIMESLOT_EXCEPTION+'/'+params.id)
            .then(response => {
				setName(response.data.name);
				if(timeslots.length > 0)
					setTimeslotId(response.data.timeslotId);
				setSlotDateFrom(response.data?.slotDateFrom?.split('T')[0]);
				setSlotDateTo(response.data?.slotDateTo?.split('T')[0]);
				setDaysOfWeek(response.data?.daysOfWeek);
				setSelectedDets(response.data.detValues);
            })
            .catch(error => {
                console.log(error)
                // seterrorMsg('Loading Failed');
            })
    }, [timeslots]);

    useEffect(() => {
		const tempSlots = [...timeslots];
		const temp = tempSlots.find(el => el.value === timeslotId);
		if(temp)
		{
			setDets(temp?.dets);
			for(const t of temp?.dets)
			{
				t.selected = selectedDets.includes(t.id)
			}
		}
		setTimeSlots(tempSlots);			
    }, [timeslotId]);

  const handleInput = (key='', type, val) => {
    {
		console.log('key, type, val', key, type, val)
		const newDets = [...selectedDets];
		if(type)
			newDets.push(val);
		else
		{
			const i = newDets.indexOf(val);
			newDets.splice(i, 1);
		}
		console.log('newDets', newDets)
		setSelectedDets(newDets);
    }

  }
	// Validate form before submission
  const validateForm = () => {
		const today = moment().set({hour:0,minute:0,second:0,millisecond:0});
		const start = moment(slotDateFrom, 'YYYY-MM-DD');
		const end = moment(slotDateTo, 'YYYY-MM-DD');
		if((slotDateFrom==null || slotDateTo==null || slotDateFrom=='' || slotDateTo=='') && daysOfWeek.length == 0)
		{
			setErrorMsg("Enter range or recurring days");
			return false;
		}
		if(start.diff(end)>=0 && daysOfWeek.length == 0)
		{
			setErrorMsg("Start date should not be after end date");
			return false;
		}
		
		if(today.diff(start)>0 && daysOfWeek.length == 0)
		{
			setErrorMsg("You must start from this today on");
			return false;
		}

		if (daysOfWeek.length === 0 && slotDateFrom=='') {
			setErrorMsg("must have at least one recurring day");
			return false;
		}


		return true;
  };

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setErrorMsg("");

		if (!validateForm()) {
			setLoading(false);
			return;
		}

		try {
			const response = post(ADD_TIMESLOT_EXCEPTION, {name, timeslotId, slotDateFrom: slotDateFrom==''?null:slotDateFrom, slotDateTo: slotDateTo==''?null:slotDateTo, daysOfWeek, detValues:selectedDets})
        .then(async response => {
          if (response.code === 201) {
            navigate(`/timeslots/exceptions`, {
              state: { successMsg: response.message || "Time slot created successfully" },
            });
          }
        })

		} catch (error) {
			console.error("Error creating time slot:", error);
		} finally {
			setLoading(false); 
		}
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs
						title="Time Slots Exceptions"
						breadcrumbItem="Add Time Slot Exception"
					/>

					<Form onSubmit={handleSubmit}>
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										{errorMsg && <Alert color="danger">{errorMsg}</Alert>}

										<Row>
											<FormGroup className="col-md-12">
												<Row>
												<div className=" col-md-4 mt-2">
													<Label className="form-label">
														<Trans>Name</Trans>
													</Label>
													<Input
														type="text"
														value={name}
														onChange={e => setName(e.target.value)}
														required
													/>
												</div>
												<div className="form-group col-md-4 mt-2">
													<Label className="form-label"><Trans>Time Slot</Trans></Label>
													<Select
													name="timeslotId"
													value={timeslots.filter(option => {return timeslotId==option.value})}
													options={timeslots} 
													className="form-control select2"
													onChange={(e) => setTimeslotId(e.value)}
													required
													/>
												</div>

												<div className=" col-md-4 mt-2">
													<Label className="form-label">
														<Trans>Date From</Trans>
													</Label>
													<Input
														type="Date"
														value={slotDateFrom}
														onChange={e => setSlotDateFrom(e.target.value)}
														
													/>
												</div>

												<div className=" col-md-4 mt-2">
													<Label className="form-label">
														<Trans>Date To</Trans>
													</Label>
													<Input
														type="Date"
														value={slotDateTo}
														onChange={e => setSlotDateTo(e.target.value)}
														
													/>
												</div>
												</Row>
											</FormGroup>

											<FormGroup className="col-md-12">
                        <Row>
												<div className=" col-md-6 mt-2">
												<Label>
													<Trans>Type</Trans>
												</Label>
												<Input
													type="select"
													value={status}
													onChange={e => setStatus(parseInt(e.target.value))}
													required
												>
													<option value={1}>Use date range or recurring days to except</option>
													<option value={2}>Use both date range and recurring days to except</option>
												</Input>
												</div>
												<div className=" col-md-6 mt-2">
													<Label>
														<Trans>Recurring Days</Trans>
													</Label>
													<Select
														isMulti
														options={dayOptions}
														value={dayOptions.filter(option =>
															daysOfWeek.includes(option.value)
														)}
														onChange={selected =>
															setDaysOfWeek(selected.map(item => item.value))
														}
														className="basic-multi-select"
														classNamePrefix="select"
														
													/>
													</div>
                          </Row>
												</FormGroup>
										</Row>
                    <Row>
											<h3 className="mt-4">
												<Trans>Time Slot Details</Trans>
											</h3>
                      {dets?.map((det,index) => (
                        <div  key={index}>
                          <TimeSlotDet setDet={setDets} handleInput={handleInput} akey={index} det={det} showSelected={true} />
                        </div>

                      ))}

                    </Row>

									</CardBody>
								</Card>
							</Col>
										<div className="mt-4">
											<Button type="submit" color="primary" >
												{loading ? "Processing..." : "Submit"}
											</Button>
										</div>
						</Row>
					</Form>
				</div>
			</div>
		</React.Fragment>
	)
};

export default AddTimeSlotException;
